import React from 'react';
import type {Row} from '@tanstack/react-table';
import {FormGroup, Input} from 'reactstrap';

interface ComponentProps<T> {
    row: Row<T>;
}

const ColumnSelectCell = <T,>({row}: ComponentProps<T>): JSX.Element => {
    return (
        <FormGroup check>
            <Input
                type="checkbox"
                id={row.id}
                checked={row.getIsSelected()}
                onChange={row.getToggleSelectedHandler()}
                aria-label="Select/Deselect"
            />
        </FormGroup>
    );
};

export default ColumnSelectCell;
